// frontend/src/components/dashboard/Panel.js
//
// The box everything on the dashboard sits in.
//
// Written once because the page had five different ideas of what a panel was:
// some an outlined Paper with a heading floating inside it, one a bare Box, one
// a heading with no box at all and one a text link with nothing around it. Read
// down the page, nothing said "a new thing starts here", so the sections ran
// into one another.
//
// A header band, a body, and a footer that holds the one link out to the full
// list. Every panel on the page is this.

import React from 'react';

import { Box, Button, Stack } from '@mui/material';

import PanelHeading from './PanelHeading';

const LINE = '#d7e5da';

export default function Panel({
  title,
  caption,
  right,
  footer,
  footerLabel,
  onFooterClick,
  children,
  sx,
  bodySx,
}) {
  return (
    <Box
      sx={{
        borderRadius: 3,
        border: '1px solid',
        borderColor: LINE,
        bgcolor: 'background.paper',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        ...sx,
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1.25,
          borderBottom: '1px solid',
          borderColor: LINE,
          background: '#f6faf7',
          flexShrink: 0,
        }}
      >
        <PanelHeading title={title} caption={caption} right={right} />
      </Box>

      {/* The body grows so every panel in a row ends at the same line. */}
      <Box sx={{ flex: 1, minHeight: 0, ...bodySx }}>{children}</Box>

      {footer || footerLabel ? (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            px: 1.25,
            py: 0.75,
            borderTop: '1px solid',
            borderColor: LINE,
            background: '#fafcfb',
            flexShrink: 0,
          }}
        >
          {footer || (
            <Button
              size="small"
              onClick={onFooterClick}
              sx={{ fontWeight: 800, color: '#034f2d' }}
            >
              {footerLabel}
            </Button>
          )}
        </Stack>
      ) : null}
    </Box>
  );
}
